import classnames from "classnames";
import styles from "./horizontalSeparator.module.scss";

function HorizontalSeparator({ className }:{className?:string}) {
  return (
    <hr
      className={classnames({
        [styles.separator_line]: true,
        [className!]: className,
      })}
    />
  );
}

export default HorizontalSeparator;
